import useProjects from "hooks/trpc/useProjects"
import { useCallback } from "react"
import { FavoriteIconButton } from "./FavoriteIconButton"
import { useProjectFavorites } from "./useProjectFavorites"

/**
 * A wrapper around the FavoriteIconButton component for toggling project
 * favorites. Will fetch the project data and pass it to the FavoriteIconButton
 * component, though we could consider ripping this out.
 */

export const FavoriteProjectIconButton = ({
  dataId,
  className,
}: {
  dataId: string
  className?: string
}) => {
  const { data: { data: projects = [] } = {}, isLoading: isLoadingProjects } =
    useProjects()
  const project = projects.find((project) => project.data_id === dataId)
  const { checkIsFavorited, toggleFavorite } = useProjectFavorites()
  const isFavorited = checkIsFavorited(dataId)

  const handleToggleFavorite = useCallback(() => {
    if (isLoadingProjects || !project) {
      return
    }

    toggleFavorite({
      id: dataId,
      data: {
        name: project.name,
        href: `/projects/${project.slug}`,
        logo: project.logo ?? null,
        symbol: project.symbol ?? null,
      },
    })
  }, [dataId, isLoadingProjects, project, toggleFavorite])

  return (
    <FavoriteIconButton
      isFavorited={isFavorited}
      handleToggleFavorite={handleToggleFavorite}
      className={className}
    />
  )
}
